import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {BookCompanyForVersionPayload} from '../../actions/companyCommand';
import Event from '../../actions/event';
import Api from '../../../api';

const onBookCompanyForVersion = function*(data: BookCompanyForVersionPayload) {
    // Step 1: Save booking
    try {
        yield call(Api.Command.bookCompanyForVersion, {
            companyId: data.companyId,
            version: data.version,
            bookedQualityCheck: data.bookedQualityCheck,
            bookedQualityCheckDate: data.bookedQualityCheckDate,
            bookedMarketing: data.bookedMarketing,
            bookedMarketingDate: data.bookedMarketingDate,
        });

        yield put(Event.Company.companyBookingAdded({
            companyId: data.companyId,
            version: data.version,
            qualityCheck: data.bookedQualityCheck,
            qualityCheckDate: data.bookedQualityCheckDate,
            marketing: data.bookedMarketing,
            marketingDate: data.bookedMarketingDate,
        }));

        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: `Buchung für Version ${data.version} wurde erfolgreich gespeichert.`,
        }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Die Buchung konnte nicht gespeichert werden.',
        }));
        return;
    }

    // Step 2: Generate contract (non-critical — booking already saved)
    if (data.generateContract) {
        try {
            yield call(Api.Command.generateBookingContract, {
                companyId: data.companyId,
                email: data.email,
                bookedQualityCheck: data.bookedQualityCheck,
                rerenderContract: false,
                version: data.version,
            });
        } catch (e) {
            yield put(Command.Notification.enqueueNotification({
                severity: 'warning',
                message: 'Buchung gespeichert, aber der Vertrag konnte nicht erstellt werden.',
            }));
        }
    }
};

export function* bookCompanyForVersionFlow() {
    while (true) {
        const action: Action<BookCompanyForVersionPayload> = yield take(
            Command.Company.bookCompanyForVersion.toString(),
        );

        yield fork(onBookCompanyForVersion, action.payload);
    }
}
